module.exports = __webpack_public_path__ + "static/media/icx.07c6d678.svg";